import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 451-hand-like
 * @see {GlyphIcon}
 */
const HandLikeIcon = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d = "M10,14v9a1,1,0,0,1-1,1H5V13H9A1,1,0,0,1,10,14Zm15.86182,1.15448-.61036-1.52588A1,1,0,0,0,24.32294,13H18.2215a.5.5,0,0,1-.46814-.6756L18.809,9.50934A2.99909,2.99909,0,0,0,19,8.456V6.5a1.50043,1.50043,0,0,0-1.1123-1.44934.49352.49352,0,0,0-.12751-.01672.51036.51036,0,0,0-.431.23919L15.11255,8.81989q-.11252.18-.24.35L12,13v9.5l.91418.91418A2.00018,2.00018,0,0,0,14.32843,24h7.31751a2,2,0,0,0,1.85693-1.25726l2.37585-6.89093A1.00018,1.00018,0,0,0,25.86182,15.15448Z";
	}
}

export default HandLikeIcon;